export default function GlobalStyles() {
	// 全局样式已迁移到 index.css
	return null
}
